"use client";

import { c as _c } from "react/compiler-runtime";
import { DELEGATION_USE_CASES, SUPPORTED_COLLECTIONS } from "@/components/delegation/delegation-constants";
import { publicEnv } from "@/config/env";
import { DELEGATION_ALL_ADDRESS, MEMES_CONTRACT } from "@/constants";
import { Delegation } from "@/entities/IDelegation";
import { areEqualAddresses } from "@/helpers/Helpers";
import { fetchAllPages } from "@/services/6529api";
import { faFileUpload } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useRef, useState } from "react";
import { Button, Col, Container, Form, Row } from "react-bootstrap";
import styles from "./MappingTool.module.scss";
const csvParser = require("csv-parser");
export default function DelegationMappingTool() {
  const $ = _c(59);
  const inputRef = useRef(null);
  const [dragActive, setDragActive] = useState(false);
  const [file, setFile] = useState();
  const [collection, setCollection] = useState("0");
  const [useCase, setUseCase] = useState(0);
  const [processing, setProcessing] = useState(false);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [delegations, setDelegations] = useState(t0);
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [];
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const [csvData, setCsvData] = useState(t1);
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = function submit() {
      setProcessing(true);
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const submit = t2;
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => {
      (inputRef.current as any).click();
    };
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const handleUpload = t3;
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = function (e) {
      e.preventDefault();
      e.stopPropagation();
      if (e.type === "dragenter" || e.type === "dragover") {
        setDragActive(true);
      } else {
        if (e.type === "dragleave") {
          setDragActive(false);
        }
      }
    };
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const handleDrag = t4;
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = function (e_0) {
      e_0.preventDefault();
      e_0.stopPropagation();
      setDragActive(false);
      if (e_0.dataTransfer.files && e_0.dataTransfer.files[0]) {
        setFile(e_0.dataTransfer.files[0]);
      }
    };
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  const handleDrop = t5;
  let t6;
  if ($[6] !== delegations) {
    t6 = function getForAddress(address, collection_0, useCase_0) {
      const myDelegations = delegations.find(d => areEqualAddresses(address, d.from_address) && areEqualAddresses(collection_0, d.collection) && useCase_0 === d.use_case);
      return myDelegations;
    };
    $[6] = delegations;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  const getForAddress = t6;
  let t7;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = function downloadCsvFile(data) {
      const csvString = data.map(_temp).join("\n");
      const blob = new Blob([csvString], {
        type: "text/csv;charset=utf-8;"
      });
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.setAttribute("href", url);
      link.setAttribute("download", "output.csv");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    };
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  const downloadCsvFile = t7;
  let t8;
  if ($[9] !== collection || $[10] !== file || $[11] !== processing || $[12] !== useCase) {
    t8 = () => {
      const fetchDelegations = async function fetchDelegations(url_0) {
        fetchAllPages(url_0).then(delegations_0 => {
          setDelegations(delegations_0);
          const reader = new FileReader();
          reader.onload = async () => {
            const data_0 = reader.result;
            const results = [];
            const parser = csvParser({
              headers: true
            }).on("data", row => {
              results.push(row._0);
            }).on("end", () => {
              setCsvData(results);
            }).on("error", _temp2);
            parser.write(data_0);
            parser.end();
          };
          reader.readAsText(file);
        });
      };
      if (processing) {
        const useCaseFilter = `&use_case=1,${useCase}`;
        const collectionFilter = `&collection=${DELEGATION_ALL_ADDRESS},${collection}`;
        const initialUrl = `${publicEnv.API_ENDPOINT}/api/delegations?${useCaseFilter}${collectionFilter}`;
        fetchDelegations(initialUrl);
      }
    };
    $[9] = collection;
    $[10] = file;
    $[11] = processing;
    $[12] = useCase;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== processing) {
    t9 = [processing];
    $[14] = processing;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  useEffect(t8, t9);
  let t10;
  if ($[16] !== csvData || $[17] !== delegations || $[18] !== getForAddress || $[19] !== useCase) {
    t10 = () => {
      const out = [];
      if (csvData.length > 0 && delegations.length > 0) {
        csvData.map(address_0 => {
          const memesUseCase = getForAddress(address_0, MEMES_CONTRACT, useCase);
          if (memesUseCase) {
            out.push(memesUseCase.to_address);
          } else {
            const memesAll = getForAddress(address_0, MEMES_CONTRACT, 1);
            if (memesAll) {
              out.push(memesAll.to_address);
            } else {
              const anyUseCase = getForAddress(address_0, DELEGATION_ALL_ADDRESS, useCase);
              if (anyUseCase) {
                out.push(anyUseCase.to_address);
              } else {
                const anyAll = getForAddress(address_0, DELEGATION_ALL_ADDRESS, 1);
                if (anyAll) {
                  out.push(anyAll.to_address);
                } else {
                  out.push(address_0);
                }
              }
            }
          }
        });
        downloadCsvFile(out);
        setProcessing(false);
      }
    };
    $[16] = csvData;
    $[17] = delegations;
    $[18] = getForAddress;
    $[19] = useCase;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== csvData) {
    t11 = [csvData];
    $[21] = csvData;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  useEffect(t10, t11);
  let t12;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <Row><Col>Upload File <span className="font-color-h">(.csv)</span></Col></Row>;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  const t13 = `${styles.uploadArea} ${dragActive ? styles.uploadAreaActive : ""}`;
  let t14;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <div><FontAwesomeIcon icon={faFileUpload} className={styles.uploadIcon} /></div>;
    $[24] = t14;
  } else {
    t14 = $[24];
  }
  let t15;
  if ($[25] !== file) {
    t15 = file ? <div>{file.name}</div> : <div>Drag and drop your file here, or click to upload</div>;
    $[25] = file;
    $[26] = t15;
  } else {
    t15 = $[26];
  }
  let t16;
  if ($[27] !== t13 || $[28] !== t15) {
    t16 = <Row className="pt-2"><Col><Container className={t13} onClick={handleUpload} onDrop={handleDrop} onDragEnter={handleDrag} onDragLeave={handleDrag} onDragOver={handleDrag}>{t14}{t15}</Container></Col></Row>;
    $[27] = t13;
    $[28] = t15;
    $[29] = t16;
  } else {
    t16 = $[29];
  }
  let t17;
  if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <Row className="pt-4"><Col>Select Collection</Col></Row>;
    $[30] = t17;
  } else {
    t17 = $[30];
  }
  let t18;
  let t19;
  let t20;
  if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = e_1 => {
      setCollection(e_1.target.value);
    };
    t19 = <option value="0" disabled={true}>...</option>;
    t20 = SUPPORTED_COLLECTIONS.map(_temp3);
    $[31] = t18;
    $[32] = t19;
    $[33] = t20;
  } else {
    t18 = $[31];
    t19 = $[32];
    t20 = $[33];
  }
  let t21;
  if ($[34] !== collection) {
    t21 = <Row className="pt-2"><Col><Form.Select className={`${styles.formInput}`} value={collection} onChange={t18}>{t19}{t20}</Form.Select></Col></Row>;
    $[34] = collection;
    $[35] = t21;
  } else {
    t21 = $[35];
  }
  let t22;
  if ($[36] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = <Row className="pt-4"><Col>Select Use Case</Col></Row>;
    $[36] = t22;
  } else {
    t22 = $[36];
  }
  let t23;
  let t24;
  let t25;
  if ($[37] === Symbol.for("react.memo_cache_sentinel")) {
    t23 = e_2 => {
      const newCase = Number.parseInt(e_2.target.value);
      setUseCase(newCase);
    };
    t24 = <option value={0} disabled={true}>...</option>;
    t25 = DELEGATION_USE_CASES.map(_temp4);
    $[37] = t23;
    $[38] = t24;
    $[39] = t25;
  } else {
    t23 = $[37];
    t24 = $[38];
    t25 = $[39];
  }
  let t26;
  if ($[40] !== useCase) {
    t26 = <Row className="pt-2"><Col><Form.Select className={`${styles.formInput}`} value={useCase} onChange={t23}>{t24}{t25}</Form.Select></Col></Row>;
    $[40] = useCase;
    $[41] = t26;
  } else {
    t26 = $[41];
  }
  let t27;
  if ($[42] === Symbol.for("react.memo_cache_sentinel")) {
    t27 = <Row className="pt-4"><Col className="font-color-h font-smaller">Note: If the selected collection or use case delegation is not found, the tool will automatically switch to using delegations for "Any" or "All" options respectively.</Col></Row>;
    $[42] = t27;
  } else {
    t27 = $[42];
  }
  const t28 = `${styles.submitBtn} ${useCase === 0 || processing || !file ? styles.submitBtnDisabled : ""}`;
  let t29;
  if ($[43] === Symbol.for("react.memo_cache_sentinel")) {
    t29 = () => submit();
    $[43] = t29;
  } else {
    t29 = $[43];
  }
  const t30 = processing ? "Processing" : "Submit";
  let t31;
  if ($[44] !== processing) {
    t31 = processing && <div className="d-inline"><div className={`spinner-border ${styles.loader}`} role="status"><span className="sr-only" /></div></div>;
    $[44] = processing;
    $[45] = t31;
  } else {
    t31 = $[45];
  }
  let t32;
  if ($[46] !== t28 || $[47] !== t30 || $[48] !== t31) {
    t32 = <Row className="pt-3"><Col><Button className={t28} onClick={t29}>{t30}{t31}</Button></Col></Row>;
    $[46] = t28;
    $[47] = t30;
    $[48] = t31;
    $[49] = t32;
  } else {
    t32 = $[49];
  }
  const t33 = file?.fileName;
  let t34;
  if ($[50] === Symbol.for("react.memo_cache_sentinel")) {
    t34 = e_3 => {
      if (e_3.target.files) {
        const f = e_3.target.files[0];
        setFile(f);
      }
    };
    $[50] = t34;
  } else {
    t34 = $[50];
  }
  let t35;
  if ($[51] !== t33) {
    t35 = <Form.Control ref={inputRef} className={`${styles.formInputHidden}`} type="file" accept=".csv" value={t33} onChange={t34} />;
    $[51] = t33;
    $[52] = t35;
  } else {
    t35 = $[52];
  }
  let t36;
  if ($[53] !== t16 || $[54] !== t21 || $[55] !== t26 || $[56] !== t32 || $[57] !== t35) {
    t36 = <Container className={styles.toolArea} id="mapping-tool-form">{t12}{t16}{t17}{t21}{t22}{t26}{t27}{t32}{t35}</Container>;
    $[53] = t16;
    $[54] = t21;
    $[55] = t26;
    $[56] = t32;
    $[57] = t35;
    $[58] = t36;
  } else {
    t36 = $[58];
  }
  return t36;
}
function _temp4(uc) {
  return <option key={`delegation-tool-select-use-case-${uc.use_case}`} value={uc.use_case}>#{uc.use_case} - {uc.display}</option>;
}
function _temp3(sc) {
  return <option key={`delegation-tool-select-collection-${sc.contract}`} value={sc.contract}>{sc.display}</option>;
}
function _temp2(err) {
  console.error(err);
}
function _temp(d_0) {
  return d_0.toLowerCase();
}